import React, { PureComponent, Fragment } from 'react';
import renderHTML from 'react-render-html';
import { Helmet } from "react-helmet";
import Header from 'components/header/header.component';
import Gallery from 'components/gallery/gallery.component';

// Styles
import {
  StyledTextWrapper,
} from "./textSubsite.style";

import {
  StyledElementHeaderTitle,
  StyledElementHeaderDescription
} from 'styledElements';

// Utils
import { urlParser } from "../../utils/urlParser";

// Texts
import text from 'i18l';


import {
  StyledElementWrapper,
  StyledElementWrapperCenter
} from 'styledElements';


class ProgramDetailsComponent extends PureComponent {
  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    const {match: {params: { slug }}} = this.props;
    const subsiteKey = urlParser(slug);
    console.log(subsiteKey);

    return (
      <Fragment>
        <Helmet>
          <title>Myjnia Koło - 24H || Program: {text[subsiteKey].TITLE}</title>
        </Helmet>
        <Header/>
        <StyledElementWrapper>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                {text[subsiteKey].TITLE}
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                {text[subsiteKey].DESCRIPTION}
              </StyledElementHeaderDescription>
            </header>
            <StyledTextWrapper>
              {renderHTML(text[subsiteKey].TEXT)}
              {text[subsiteKey].ADDITIONAL_TEXT ? renderHTML(text[subsiteKey].ADDITIONAL_TEXT) : null}
              {text[subsiteKey].GALLERY ?
                <Gallery
                  images={text[subsiteKey].GALLERY}
                />
                : null }
            </StyledTextWrapper>


          </StyledElementWrapperCenter>
        </StyledElementWrapper>
      </Fragment>
    );
  }
}

export default ProgramDetailsComponent;



// WEBPACK FOOTER //
// ./src/routes/textSubsite/textSubsite.component.js